import './style.scss';
import { NavLink, isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { CustomerPagePath } from 'views/constants/enums/pageTitle';
import { MainLogo } from 'views/components/organisms/leftNav';

const createErrorMessage = (error: any) => {
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return 'お探しのページが見つかりませんでした。';
    }
  }

  return '申し訳ありません。エラーが発生しました。';
};

export const ErrorPage = () => {
  const error = useRouteError();

  let errorMessage = createErrorMessage(error);

  return (
    <>
      <div className="errorPage">
        <div className="errorPage_header">
          <MainLogo />
        </div>
        <div className="errorPage_message">{errorMessage}</div>
        <NavLink className="errorPage_link" to={CustomerPagePath.Root}>
          TOPに戻る
        </NavLink>
      </div>
    </>
  );
};
